import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './login.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from 'react-redux';
import * as loginActions from './loginActions';
import * as moduleActions from '../moduleActions';
import * as repositoryActions from '../../../../Store/Actions/repositoryActions';


class Login extends Component {
    constructor(props) {
      super(props);
      // State is in reducers
      this.state = {
        user:{ARCS:this.props.user.arcs,FullName:this.props.user.fullName,Login:this.props.user.login, Password:"**********",Language:"",Domain:"4",Password2:""},
        moduleName:"LOGIN",
      };

  }

    toggleConnect = () =>{
        this.props.disconnect();

    }
    toggleExpand = () =>{
      this.props.onToggleOpen();
    }

    onChangeLogin = (event)=>{
      var userTmp = {...this.state.user};
      userTmp.Login = event.target.value;
      this.setState({user:userTmp});
    }

    componentDidMount = () =>{
      // CREATE MODULE DATA IN STATE MODULE OBJECT
      this.props.registerModule(this.state.moduleName);
      document.addEventListener('click', this.handleClickOutside, true);
      
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    
    handleClickOutside = (event) => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
          //this.props.toggleExpand("");
        }
    }

    onChangePassword = (event)=>{
      var userTmp = {...this.state.user};
      userTmp.Password = event.target.value;
      this.setState({user:userTmp});
    }
    onChangePassword2 = (event)=>{
      var userTmp = {...this.state.user};
      userTmp.Password2 = event.target.value;
      this.setState({user:userTmp});
    }
    onChangeDomain = (event)=>{
      var userTmp = {...this.state.user};
      userTmp.Domain = event.target.value;
      this.setState({user:userTmp});
    }
    onChangeLanguage = (event)=>{
      var userTmp = {...this.state.user};
      userTmp.Language = event.target.value;
      this.setState({user:userTmp});
    }
  
    buildUserblock = () => {
      var user = this.state.user;

      return(
        <div className="loginBlock">
          <div className="extendBlocksHeader">
            <span>User profile ({this.state.user.ARCS}) </span><FontAwesomeIcon onClick={this.toggleConnect.bind(this)} icon="sign-out-alt"/>
          </div>
          <div className="extendBlockBody">
            <div className="profileLine">
              <span>FullName</span>
              <div>{user.FullName}</div>
            </div>
            <div className="profileLine">
              <span>Login</span>
              <div>{user.Login}</div>
            </div>
            <div className="loginLine">
              <span>Password</span>
              <input type="password" onChange={this.onChangePassword.bind()} value={user.Password} />
            </div>
            <div className="loginLine">
              <span>Confirm Password</span>
              <input type="password" onChange={this.onChangePassword2.bind()} value={user.Password}/>
            </div>
            <div className="loginLine">
              <span>Language</span>
              <select onChange={this.onChangeLanguage.bind()}>
                <option>Français</option>
                <option>Français</option>
                <option>Français</option>
                <option>Français</option>
              </select>
            </div>
            <div className="loginLine">
              <div className="nb_button">Save</div>
            </div>
          </div>
        </div>
      )
    }
  
    render() {
      
      var userBlock = this.buildUserblock();

      return (
        <div className={this.props.extendedModule === this.state.moduleName?"header-column extended":"header-column"} >
          <FontAwesomeIcon  icon="user" onClick={this.props.toggleExpand.bind(this,this.state.moduleName)}/>
          {/* <div className="alert"></div> */}
          <div className="extendBlocks">
            {userBlock}
          </div>
        </div>
      );
    }
  }
  
  const mapStateToProps = (state) => {    
    return {  
      isConnected: state.appReducer.isConnected,
      serverStatus: state.apiReducer.server.Status,
      session: state.apiReducer.session,
      loginMessage: state.apiReducer.loginMessage,
      notificationHistory: state.appReducer.notificationHistory,
      extendedModule: state.appReducer.extendedModule,
      user:state.globalReducer.user,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      registerModule: (type) =>dispatch(moduleActions.registerModule(type)),
      disconnect: () => dispatch(repositoryActions.disconnect()),
      toggleExpand: (type) =>dispatch(moduleActions.toggleExpand(type)),
      loginTry: (user,obj)=>dispatch(repositoryActions.loginTry(user,obj)),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(Login);
  